import BicoloredTitle from "components/BicoloredTitle";
import GridLayout from "components/GridLayout";
import Section from "components/Section";
import Banner from "components/Banner";
import Header from "components/Header";
import Layout from "components/Layout";

export default function ExperiencePage() {
  return (
    <Layout>
      <Header
        className={`bg-[url('/images/persons/virginie-arbour-maynard.png')]`}
        title={"Expériences d'apprentissage"}
      />
      <main>
        <Banner
          title="Un avantage concurrentiel"
          text={
            "Nous concevons des expériences d’apprentissage qui valorisent le développement des compétences au sein de votre organisation."
          }
          color={"red"}
        />
        <div className="bg-pink-salt">
          <Section className="pt-24">
            <GridLayout>
              <div>
                <BicoloredTitle
                  subtitle="Mobilisateur, pertinent, mesurable et durable"
                  primary={"De l’événement de formation à"}
                  secondary={"l’expérience d’apprentissage"}
                  primaryColor={"green"}
                />
                <p className="mt-8 text-3xl leading-1.2 text-neutral-600">
                  Expérience apprenant
                  <br />
                  <br />
                  Stratégie de formation: on ne veut pas aller là.
                  <br />
                  <br />
                  Design et architecture pédagogique -
                </p>
              </div>
            </GridLayout>
          </Section>
        </div>
      </main>
    </Layout>
  );
}
